import { render, staticRenderFns } from "./detailTrainee.vue?vue&type=template&id=30cd7818&scoped=true"
import script from "./detailTrainee.vue?vue&type=script&lang=js"
export * from "./detailTrainee.vue?vue&type=script&lang=js"
import style0 from "./detailTrainee.vue?vue&type=style&index=0&id=30cd7818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cd7818",
  null
  
)

export default component.exports